// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-group-dynamic-increment__row{position:relative;padding-right:34px!important}.m-group-dynamic-increment__close-btn{position:absolute!important;bottom:36px;right:0}", ""]);
// Exports
module.exports = exports;
